import styled from 'styled-components'
import Logo from '../../components/Logo/Logo'

const Container = styled.nav`
  padding: 50px 0;
  display: flex;
  justify-content: center;
  margin-top: 40px;
`
const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  a {
    transition: 0.2s ease-in;

    &:hover {
      transition: 0.2s ease-in;
      opacity: 0.6;
    }
  }
`
const SocialWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .sharethis-inline-share-buttons {
    margin-right: 10px;
  }
`

export default function Navbar() {
  return (
    <Container>
      <div className="container">
        <Wrapper className="navbar__wrapper">
          <Logo />
          <SocialWrapper className="social__wrapper">
            <div className="sharethis-inline-share-buttons"></div>
            <a
              href="https://www.producthunt.com/posts/grammarly-dark?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-grammarly-dark"
              target="_blank"
              rel="noreferrer noopener"
            >
              <img
                src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=208243&theme=dark"
                alt="GDark - Dark mode browser extension | Product Hunt Embed"
                width={250}
                height={54}
              />
            </a>
          </SocialWrapper>
        </Wrapper>
      </div>
    </Container>
  )
}
